import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a951f50"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "anomaly-cell" };
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskAnomalyColumn',
    props: {
        anomaliesCount: {}
    },
    setup(__props) {
        const props = __props;
        const anomalyLabel = computed(() => {
            return props.anomaliesCount + (props.anomaliesCount == 1 ? " anomaly" : " anomalies");
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", {
                    "data-testid": "anomaly-cell-label",
                    class: _normalizeClass(props.anomaliesCount == 0 ? 'anomaly-cell-label has-no-anomalies' : 'anomaly-cell-label has-anomalies')
                }, [
                    _createElementVNode("i", {
                        class: _normalizeClass(`pi  ${props.anomaliesCount == 0 ? 'pi-check' : 'pi-exclamation-triangle'}`),
                        style: { "margin-right": "5px" }
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(anomalyLabel.value), 1)
                ], 2)
            ]));
        };
    }
});
